export const enum FocusGroups {
  BOTTOM_SHEET = 'bottom-sheet',
  LOOKUP_CHOICE = 'lookup-choice',
  CHOOSE_PHOTO_BANNER = 'choose-photo-banner',
  MODAL = 'modal',
  MODAL_HEADER = 'modal-header',
  HEADER = 'header',
  TOAST_NOTIFICATION = 'toast-notification',
  CONFIGURATION = 'configuration',
  SECOND_LEVEL_OF_CONFIGURATION = 'second-level-of-configuration',
  BOTTOM_BAR = 'bottom-bar',
  PRODUCT = 'product',
  DRAWER = 'drawer',
  BEFORE_PRODUCT = 'before-product',
  AFTER_PRODUCT = 'after-product',
  TOOLTIP = 'tooltip',
  TOOLBAR_TILES = 'toolbar-tiles',
  TOOLBAR_OPTIONS_HEADER = 'toolbar-options-header',
  TOOLBAR_OPTIONS = 'toolbar-options',
  GROUP_SELECTOR_HEADER = 'group-selector-header',
  GROUP_ACTION_BAR = 'group-action-bar',
  UNSUPPORTED_ENV = 'unsupported-env',
}

// Number of focusOrder slots reserved per product in FocusGroups.PRODUCT
// (checkbox, paper, edit, options, quantity subtract, quantity input, quantity add / quality alert).
// Multiply by a product's list index to keep each product's slots unique.
export const PRODUCT_FOCUS_ORDER_STEP = 7;

// Number of focusOrder slots reserved per grid item in ModalAdjustCrops (FocusGroups.MODAL)
// (tile itself, zoom-out button, zoom slider, zoom-in button).
// Multiply by the item's list index to keep each tile's slots unique.
export const ADJUST_CROPS_ITEM_FOCUS_ORDER_STEP = 4;

export const FOCUS_GROUPS_ORDER_PRIORITY: FocusGroups[] = [
  FocusGroups.MODAL_HEADER,
  FocusGroups.BOTTOM_SHEET,
  FocusGroups.MODAL,
  FocusGroups.DRAWER,
  FocusGroups.HEADER,
  FocusGroups.GROUP_SELECTOR_HEADER,
  FocusGroups.GROUP_ACTION_BAR,
  FocusGroups.CONFIGURATION,
  FocusGroups.TOOLBAR_TILES,
  FocusGroups.SECOND_LEVEL_OF_CONFIGURATION,
  FocusGroups.TOOLBAR_OPTIONS_HEADER,
  FocusGroups.LOOKUP_CHOICE,
  FocusGroups.TOOLBAR_OPTIONS,
  FocusGroups.BEFORE_PRODUCT,
  FocusGroups.PRODUCT,
  FocusGroups.AFTER_PRODUCT,
  FocusGroups.CHOOSE_PHOTO_BANNER,
  FocusGroups.BOTTOM_BAR,
  FocusGroups.TOAST_NOTIFICATION,
  FocusGroups.TOOLTIP,
  FocusGroups.UNSUPPORTED_ENV,
];
